import { PARTICIPANT_IDENTITIES } from '@shared/constants/livekit.constants';
import { TranscriptionRole } from '@shared/types/admin/conversation';

export const resolveRole = (identity: string, agentIdentity?: string): TranscriptionRole => {
  if (identity === agentIdentity || identity.startsWith(PARTICIPANT_IDENTITIES.AGENT_PREFIX)) {
    return 'assistant';
  }

  if (identity.startsWith(PARTICIPANT_IDENTITIES.SUPERVISOR_PREFIX)) return 'supervisor';

  return 'user';
};
